import { motion } from "framer-motion";
import { CheckCircle2, Rocket, Layers, Globe2 } from "lucide-react";
import { useLanguage } from "@/components/sybrax/LanguageProvider";
import { content } from "@/components/sybrax/i18n";

const icons = [CheckCircle2, Rocket, Layers, Globe2];

const Stats = () => {
    const { lang } = useLanguage();
    const stats = content[lang].stats;

    return (
        <section
            id="stats"
            data-testid="stats-section"
            className="relative pb-8 sm:pb-12 -mt-8 sm:-mt-12 lg:-mt-16"
        >
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    className="glass-card !rounded-2xl"
                >
                    <ul className="grid grid-cols-2 lg:grid-cols-4">
                        {stats.map((s, i) => {
                            const Icon = icons[i];
                            const isTopRowMobile = i < 2;
                            const isLeftColMobile = i % 2 === 0;
                            return (
                                <li
                                    key={s.label}
                                    data-testid={`stat-item-${i}`}
                                    className={[
                                        "flex items-center gap-3 sm:gap-4 px-4 sm:px-6 py-5 sm:py-6",
                                        isTopRowMobile
                                            ? "border-b lg:border-b-0 border-slate-200/70 dark:border-white/5"
                                            : "",
                                        isLeftColMobile
                                            ? "border-r lg:border-r-0 border-slate-200/70 dark:border-white/5"
                                            : "",
                                        i > 0 ? "lg:border-l lg:border-slate-200/70 lg:dark:border-white/5" : "",
                                    ].join(" ")}
                                >
                                    <div className="shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-cyan-500/10 border border-cyan-400/30 flex items-center justify-center">
                                        <Icon
                                            size={18}
                                            strokeWidth={1.6}
                                            className="text-cyan-600 dark:text-cyan-300"
                                        />
                                    </div>
                                    <div className="min-w-0 flex items-baseline gap-2 flex-wrap">
                                        {s.value && (
                                            <span className="font-display text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white tracking-tight leading-none">
                                                {s.value}
                                            </span>
                                        )}
                                        <span
                                            data-testid={`stat-label-${i}`}
                                            className="font-display text-sm sm:text-base font-medium text-slate-700 dark:text-slate-200 leading-tight"
                                        >
                                            {s.label}
                                        </span>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </motion.div>
            </div>
        </section>
    );
};

export default Stats;
